<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">手机短信登录</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-name"></i></div>
              <div class="item-inner">
                <div class="item-title label">手机号</div>
                <div class="item-input" @click="autofocus('account')">
                  <input type="text" id="account" v-model.trim="account" placeholder="帐号">
                </div>
              </div>
            </div>
          </li>
          <li v-show="type === 'phone'">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input">
                  <input style="width:6rem;display: inline;" @click="autofocus('veriCode')" id="veriCode" type="text" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div v-if="type === 'phone'" class="col-100"><a @click="login" class="button button-big button-fill button-success">登录</a></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import $ from 'jquery'
  import EMKT from '../../../emkt.js'
  import {mapState, mapMutations} from 'vuex'
//  import md5 from 'js-md5'
  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        account: '',
        type: 'phone',
        veriCode: '',
        coolDown: false,
        fromFullPath: this.$route.query.fromFullPath || '/me'
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    watch: {
      'account': function (val) {
        var _this = this
        if (val.indexOf('@') !== -1) {
          _this.type = 'email'
        } else {
          _this.type = 'phone'
        }
      }
    },
    methods: {
      ...mapMutations([
        'UPDATE_RESEARCHGROUP_MEMBER_MAP', 'UPDATE_RESEARCHGROUP_SET', 'LOGIN_STATE_UPDATE', 'CLIENT_INFO', 'EXPRESSADDRESS_UPDATE', 'INVOICE_TITLE', 'MYORDER_UPDATE', 'INVOICE_ADDRESS', 'INIT_MESSAGE'
      ]),
      getResearchGroupInfo (customerNo) {
        // customerNo = EMKT.testCustomerNo
        // 获取所有的课题组信息
        this.gcapi('getResearchGroupInfoListByCustomerNo', customerNo).then(res => {
          if (res.body.result) {
            const researchGroupMemberMap = res.body.result.bResearchGroupMemberMap
            const researchGroupSet = res.body.result.bResearchGroupList
            this.UPDATE_RESEARCHGROUP_MEMBER_MAP(researchGroupMemberMap)
            this.UPDATE_RESEARCHGROUP_SET(researchGroupSet)
            console.log('researchGroupMemberMap', researchGroupMemberMap, researchGroupSet)
          }
        })
        // 过滤掉无效的任职关系
        this.gcapi('getWorkExperienceList', customerNo).then(res => {
          if (res && res.body.result) {
            const workList = res.body.result.filter(work => {
              return work.enable === true
            })
            EMKT.setStoreItem('EmktWorkExperienceList', workList)
          } else {
            EMKT.setStoreItem('EmktWorkExperienceList', [])
          }
          console.log('EmktWorkExperienceList', EMKT.getLocalStorage('EmktWorkExperienceList'))
        })
      },
      sendVeriCode () {
        let _this = this
        if (_this.account === '' || _this.account === undefined || _this.account === '' || _this.account === null) {
          alert('请填写手机号')
          return
        }
        if (!(/^1[3-9]{1}[0-9]{9}$/.test(_this.account.replace(/\s+/g, '')))) {
          alert('请填写正确手机号格式')
          return
        }
        if (!_this.coolDown) {
          $.showPreloader('请稍候')
          _this.gcapi('gcwwwifc/requestLoginSmsCode?LoginId=' + _this.account, null)
            .then((response) => {
              $.hidePreloader()
              _this.coolDown = true
              time(document.getElementById('btn'))
              $.toast(response.body['message'])
            }, (response) => {
              $.toast(response.body['message'])
            })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      login () {
        var _this = this
        if (!_this.account || !_this.veriCode) {
          $.toast('请填写完整登陆信息')
          return
        }
        _this.gcapi('gcwwwifc/loginBySmsCode?LoginId=' + _this.account + '&Password=' + _this.veriCode + '&Code=').then(res => {
          console.log(res)
          let data = res
          if (data) {
            if (data.body.result.customerName === 'GUEST') {
              $.toast('啊哦～登陆失败了，稍后再试试吧')
            } else {
              $.toast('登录成功')
              _this.LOGIN_STATE_UPDATE(true)
              _this.gcapi('gcwwwifc/getCustomerInfo').then(res => {
                _this.CLIENT_INFO(res.body.result)
                let customerNo = res.body.result.customerInfo.customerNo
                let shareUrl = EMKT.wxShareUrl + '?introducer=' + customerNo
                $.sign.shareUrl = shareUrl
                _this.getResearchGroupInfo(customerNo)
                var ShowPromotions = EMKT.getLocalStorage('EmktShowPromotions')
                if (ShowPromotions && ShowPromotions !== null && ShowPromotions.length > 0) {
                  var showPromotionParam = {}
                  showPromotionParam.bPromotions = ShowPromotions
                  showPromotionParam.customerNo = customerNo
                  _this.gcapi('ShowPromotions', showPromotionParam).then((res) => {
                    if (res.body.result === true) {
                      var isshowPromotion = {}
                      isshowPromotion.showPromotionParam = showPromotionParam
                      isshowPromotion.show = true
                      EMKT.setLocalStorage('isshowPromotion', isshowPromotion)
                    }
                  })
                }
                // EMKT.setLocalStorage('VipPlanList', null)
                // if (_this.sessionInfo.customerInfo) {
                //   var CustomerPlanParams = {
                //     'CustomerNo': _this.sessionInfo.customerInfo.customerNo
                //   }
                //   this.gcapi('retrieveCustomerPlanInformation', CustomerPlanParams).then((response) => {
                //     var VipPlanList = response.body.result
                //     EMKT.setLocalStorage('VipPlanList', VipPlanList)
                //   })
                // }
                _this.gcapi('retrieveMyOrder').then((response) => {
                  _this.MYORDER_UPDATE(response.body.result)
//                _this.$router.push('/me')
                })
                _this.gcapi('getRecommendation', customerNo).then((res) => {
//               EMKT.setStoreItem('EmktPlain', merchList)
                  if (res.body.result.length > 0) {
                    var i = 0
                    var list = []
                    var newlist = res.body.result
                    console.log(res.body.result)
                    if (newlist.length > 15) {
                      for (i = 0; i < 15; i++) {
                        list.push(newlist[i])
                      }
                      EMKT.setStoreItem('EmktRecommendations', list)
                    } else {
                      EMKT.setStoreItem('EmktRecommendations', newlist)
                    }
                  }
                })
                EMKT.wxShare()
                _this.$router.push(this.fromFullPath)
              })
            }
          } else {
            $.toast('啊哦～登陆失败了，稍后再试试吧')
          }
        })
      },
      autofocus (id) {
        $('#' + id).focus()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PhoneNumberLogin.vue?63cfb04a